import { FaReact, FaJava, FaDatabase, FaNodeJs, FaPhp } from "react-icons/fa";
import { SiMongodb, SiReact, SiJavascript, SiCplusplus } from "react-icons/si";
import JSSEXCELLENCE from "../assets/JSSEXCELLENCE.png";
import ScreenRecorder from "../assets/ScreenRecorder.png";
import ACYSupplements from "../assets/ACYSupplements.png";
import ChessGame from "../assets/ChessGame.png";
import TherapyCabinet from "../assets/TherapyCabinet.png";
import SkiRental from "../assets/SkiRental.png";

export const skillsData = [
    {
        id: 0,
        title: "C / C++",
        icon: <SiCplusplus />,
    },
    {
        id: 1,
        title: "Java",
        icon: <FaJava />,
    },
    {
        id: 2,
        title: "JavaScript",
        icon: <SiJavascript />,
    },
    {
        id: 3,
        title: "PHP",
        icon: <FaPhp />,
    },
    {
        id: 4,
        title: "React",
        icon: <FaReact />,
    },
    {
        id: 5,
        title: "Express",
        icon: <FaNodeJs />,
    },
    {
        id: 6,
        title: "ReactNative",
        icon: <SiReact />,
    },
    {
        id: 7,
        title: "MongoDB",
        icon: <SiMongodb />,
    },
    {
        id: 8,
        title: "SQL",
        icon: <FaDatabase />,
    },
]

export const projectsData = [
    {
        name: "ACY Supplements",
        description: "ACY Supplements is an Ecommerce Gym Supplements Store. This platform built using PHP, Bootstrap and MySQL offers a comprehensive solution for managing and selling gym supplements online.",
        tech_stack: ["PHP", "Bootstrap", "MySQL"],
        open_source: false,
        image: ACYSupplements,
        url: "https://acysupplements.000webhostapp.com/",
    },
    {
        name: "Sports Club Management System",
        description: "JSS EXCELLENCE is an Integrated Management System for the Sports Club JSS EXCELLENCE Saoula. This project aims to streamline and automate the various administrative, tracking, and communication tasks involved in managing a sports club.",
        tech_stack: ["Electron", "React", "Express", "MySQL"],
        open_source: true,
        image: JSSEXCELLENCE,
        url: "https://github.com/soualahmohammedzakaria/JSS-EXCELLENCE", 
    },
    {
        name: "Chess Game",
        description: "This is a fully-featured Chess game built with React Native on an Expo template. It has multiple features such as animated moves, material advantage, themes, special moves, board flipping and more.",
        tech_stack: ["React Native", "Expo"],
        open_source: true,
        image: ChessGame,
        url: "https://github.com/soualahmohammedzakaria/React-Native-Chess-Game",
    },
    {
        name: "Therapy Cabinet Management App",
        description: "The Therapy Cabinet Management System streamlines therapy practice operations by efficiently managing appointments, patient profiles, and user accounts. It offers robust statistical analysis to monitor practice performance and patient progress. Additionally, the system administers and tracks various patient tests, ensuring a holistic approach to patient care and management.",
        tech_stack: ["Java", "JavaFX"],
        open_source: true,
        image: TherapyCabinet,
        url: "https://github.com/soualahmohammedzakaria/Therapy-Cabinet-Management-System",
    },
    {
        name: "Screen Recorder",
        description: "Screen Recorder is a lightweight desktop application built with Electron JS that allows users to capture video recordings of their screen. This application is designed for simplicity and efficiency, making it easy to start and stop recordings, select screen sources, and save videos to your local machine.",
        tech_stack: ["Electron", "Node"],
        open_source: true,
        image: ScreenRecorder,
        url: "https://github.com/soualahmohammedzakaria/Screen-Recorder",
    },
    {
        name: "Ski Rental System",
        description: "The Ski Rental System is a comprehensive solution for managing ski rental operations. The main objective of this project is to manage, organize, and represent the reservation and rental of skis for a ski resort. The system is implemented using a linked list of sub-lists and a table of records. It allows users to create, modify, delete, and browse these structures efficiently.",
        tech_stack: ["C", "Conio Library"],
        open_source: true,
        image: SkiRental,
        url: "https://github.com/soualahmohammedzakaria/Ski-Rental-System",
    }
]